import React, { useState } from "react";
import { useConfig } from "./ConfigProvider";
import Button from "./Button";
import StepHeader from "./StepHeader";
import Step from "./steps/Step";
import PromoCode from "./steps/PromoCode";
import { useTunnelData } from "./TunnelContext";
import StyledStepFooter from "./StyledStepFooter";

import "./CartSummary.scss";
import ClubDetails from "./ClubDetails";
import InternalOptins from "./components/InternalOptins";
import { useInternalOptins } from "./hooks/useInternalOptins";

export default function CartSummary({ goNext }) {
  const { tunnel } = useTunnelData();
  const config = useConfig();
  const {values: internalOptinValues, toggle: toggleInternalOptin, validation: internalOptinsValidation } = useInternalOptins(config);
  const [errorMessage, setErrorMessage] = useState(null);

  const regulars = Object.values(tunnel.regulars).filter((e) => e.count > 0);

  const internalOptinsInSummary = config?.steps?.userForm?.internalOptins?.step === "summary";

  const rp = tunnel.sales["_products"];

  //TODO do not use tunnel.{offer, options, regulars} to find in sales._products
  //DO the opossite, find the products;
  const display = {
    offer: { name: tunnel.offer.name, article: rp.find((r) => r.offerId === tunnel.offer.offer["@id"]) },
    options: tunnel.options
      .filter((o) => o && o.offer && o.offer["@id"])
      .map((o) => {
        return { id: o["@id"], name: o.name, article: rp.find((r) => r.offerId === o.offer["@id"]) };
      }),
    regulars: regulars.map(({ count, regular }) => {
      return {
        id: regular["@id"],
        count: count,
        name: regular.name,
        article: rp.find((r) => r.offerId === regular.offer["@id"]),
      };
    }),
  };

  const handleNext = () => {
    if (!internalOptinsValidation.isValid && internalOptinsInSummary) {
      Object.keys(internalOptinsValidation.errors).forEach((label) => {
        setErrorMessage(internalOptinsValidation.errors[label]);
      });
    } else {
      goNext();
    }
  }

  return (
    <Step classe="Plans" step="Contrat">
      <header>
        <StepHeader text={config.recap.title} />
      </header>
      <div>
        <article className="CartSummary">
          <ClubDetails club={tunnel.club} />
          <div className="CartSummaryContent">
            <section>
              <h4 className="CartSummaryOfferTitle">{config.recap.myOffer}</h4>
              <p style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", gap: "0 0.5rem"}}>
                <span>{display.offer.name}</span>
                <span className="amount">{display.offer.article && `${(display.offer.article.totalTI / 100).toFixed(2)} €`}</span>
              </p>
              {config.recap.offerExplanation && (
                <em style={{ marginLeft: "1.5rem", marginTop: "0.5rem", fontSize: "0.8rem", fontStyle: "italic" }}>
                  {config.recap.offerExplanation}
                </em>
              )}
            </section>
            {!!display.options.length && (
              <section>
                <h4 className="CartSummaryOptionsTitle">{config.recap.myOption}</h4>
                {display.options.map((o) => {
                  return (
                    <p
                      key={o.id}
                      style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}
                    >
                      <span>{o.name}</span>
                      <span className="amount">{o.article && `${(o.article.totalTI / 100).toFixed(2)} €`}</span>
                    </p>
                  );
                })}
              </section>
            )}
            {!!display.regulars.length && (
              <section>
                <h4 className="CartSummaryRegularsTitle">{config.recap.myCounter}</h4>
                {display.regulars.map((o) => {
                  return (
                    <p
                      key={o.id}
                      style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}
                    >
                      <span style={{ display: "flex", flexDirection: "row" }}>
                        <span style={{ fontWeight: "bold" }}>{o.count} *</span>&nbsp;<span>{o.name}</span>
                      </span>
                      <span className="amount">{o.article && `${((o.count * o.article.totalTI) / 100).toFixed(2)} €`}</span>
                    </p>
                  );
                })}
              </section>
            )}
            <hr />
            <section>
              <h4 className="CartSummaryPayByCardTitle">
                {config.payByCard ? config.recap.payByCardLabel : config.recap.payBySepaLabel}:{" "}
                <span className="payByCardAmount">{(tunnel.sales.totalTI / 100).toFixed(2)}&nbsp;€</span>
              </h4>
            </section>
            <div>{!!config.promoCode && <PromoCode />}</div>

            {internalOptinsInSummary && (
              <InternalOptins
              config={config}
              values={internalOptinValues}
              onToggle={toggleInternalOptin}
              />
            )}

          </div>
        </article>
      </div>
      <StyledStepFooter className="StyledStepFooter">
      {!!errorMessage && <p style={{ textAlign: "center", fontWeight: "bold" }} className="errorMsg">{errorMessage}</p>}

        <Button variant="primary" onClick={handleNext}>
          {config.recap.nextLabel}
        </Button>
      </StyledStepFooter>
    </Step>
  );
}
